import React from "react";

const CommonFooter = () => (
  <footer className="flex flex-row justify-center items-center my-6">
    <p className="text-sm font-light text-slate-600">
      Copyright 2022 - 2025 | Adaptive Psychology Pty LTD. Designed & Engineered
      by{" "}
      <a
        className="text-[#5153F5]"
        target="_blank"
        href="https://interstellr.com.au"
      >
        Interstellr
      </a>
      .
    </p>
  </footer>
);

export default CommonFooter;
